export const MACHINE_ICON_OPTIONS = [
  ["tractor", "Trator"],
  ["pickup", "Caminhonete"],
  ["truck", "Caminhão"],
  ["car", "Carro"],
  ["van", "Van"],
  ["offroad", "Fora de estrada"],
  ["motorcycle", "Motocicleta"],
  ["crane", "Guindaste"],
  ["colheitadeira", "Colheitadeira"],
  ["pulverizador", "Pulverizador autopropelido"],
  ["pulverizador2", "Pulverizador (barras abertas)"],
  ["polinizador", "Polinizador autopropelido"],
  ["plane", "Avião"],
  ["helicopter", "Helicóptero"],
  ["bicycle", "Bicicleta"],
  ["bus", "Ônibus"],
  ["boat", "Barco"],
  ["ship", "Navio"],
  ["train", "Trem"],
  ["tram", "Bonde"],
  ["trolleybus", "Trólebus"],
];

export const TELEMETRY_PEDESTRIAN_ID = "pedestrian";
export const ICON_SELECTION_STORAGE_KEY = "agriconnected.selectedMachineIcons";
export const DEFAULT_MACHINE_ICON = "tractor";

export function loadSelectedMachineIcons() {
  try {
    const raw = window.localStorage.getItem(ICON_SELECTION_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    return [];
  }
}

export function saveSelectedMachineIcons(ids) {
  window.localStorage.setItem(ICON_SELECTION_STORAGE_KEY, JSON.stringify(ids));
  return ids;
}

export function isKnownMachineIcon(id) {
  return MACHINE_ICON_OPTIONS.some(([value]) => value === id);
}

export function machineIconLabel(id) {
  const found = MACHINE_ICON_OPTIONS.find(([value]) => value === id);
  return found ? found[1] : "Trator";
}
